import type { FC, ReactNode } from "react";
import { DocumentTextIcon } from "@heroicons/react/24/outline";
import { cn } from "@/lib/cn";
import { DotList } from "./dot-list";
import { HorizontalScroll } from "./horizontal-scroll";

type SpecialtyPillProps = {
  specialties?: string[];
  icon?: ReactNode;
  hideLabel?: boolean;
  pill?: boolean;
  scrollable?: boolean;
  size?: "s" | "m";
  className?: string;
};

export const SpecialtyPill: FC<SpecialtyPillProps> = ({
  specialties,
  icon,
  hideLabel,
  pill,
  scrollable,
  size = "s",
  className,
}) => {
  const cleaned = (specialties ?? []).filter((item) => Boolean(item?.trim()));
  if (cleaned.length === 0) return null;

  const textSize = size === "m" ? "text-16" : "text-14";
  const list = (
    <DotList
      items={cleaned}
      truncate={!scrollable}
      itemClassName={cn("text-brand-dark-blue", textSize)}
      separatorClassName="text-brand-dark-blue"
    />
  );

  const strip = (
    <div
      className={cn(
        "flex items-center bg-tone-aqua-tint py-4",
        size === "m" ? "gap-12 px-16" : "gap-4 px-12",
        pill ? "rounded-circle" : "rounded-small",
        scrollable ? "w-max min-w-full" : "w-full overflow-hidden",
        className,
      )}
    >
      <div className="flex shrink-0 items-center gap-4">
        {icon ?? <DocumentTextIcon className="size-18 shrink-0 text-brand-dark-blue" />}
        {!hideLabel && <span className={cn("font-medium text-brand-dark-blue", textSize)}>Area Of Focus</span>}
      </div>
      {scrollable ? list : <div className="min-w-0 overflow-hidden">{list}</div>}
    </div>
  );

  if (!scrollable) return strip;

  return <HorizontalScroll className="w-full">{strip}</HorizontalScroll>;
};
